import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const baseStyles = {
  width:          '24px',
  marginTop:      '0.25rem',
  border:         'none',
  borderRadius:   '12px',
  display:        'inline-flex',
  alignItems:     'center',
  justifyContent: 'center',
  cursor:         'pointer',
  transition:     'background-color 0.15s ease-in-out',
};

/**
 * Button to expand/collapse email thread replies within iframe context
 * Uses native tooltip and inline styles
 * @param {object} props - Component properties
 * @param {boolean} props.expanded - Whether the view is currently expanded
 * @param {Function} props.onClick - Function to toggle the expanded view
 * @returns {JSX.Element} - The button element
 */
const IframeExpandThreadButton = ({
  expanded,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const title = expanded ? 'Hide thread' : 'Show thread';

  const buttonStyle = {
    ...baseStyles,
    backgroundColor: isHovered ? '#e9ecef' : '#ffffff',
  };

  return (
    <button
      type="button"
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={title}
      title={title}
    >
      <FontAwesomeIcon
        icon="ellipsis-h"
        size="2xs"
        style={{ color: '#6c757d' }}
      />
    </button>
  );
};

IframeExpandThreadButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onClick:  PropTypes.func.isRequired,
};

export default IframeExpandThreadButton;
